import '@/core/pwa.js'; // registers the service worker; manifest head tags live in partials/pwa-head
import '@fontsource/inter';
import '@fontsource/poppins';
import { loadFontAwesomeKit } from '@/core/fontawesome-kit-loader.js';
import '@/core/passkeys.js'; // exposes WebAuthn globals for the login passkey button

void loadFontAwesomeKit();
